import { useMemo } from "react";

import { OrganizationRoles, Roles } from "@/shared/utils/constants";
import { canManageRole } from "@/shared/utils/roles";
import { InvitePermissions } from "@/features/organizations/profile/types";
import { UserInviteResponse } from "@/redux/invites/types";
import { FullUserResponse } from "@/redux/users/types";

export const useInvitePermissions = (
  invite: UserInviteResponse | null | undefined,
  currentUser: FullUserResponse | null | undefined,
): InvitePermissions => {
  return useMemo(() => {
    if (!currentUser) {
      return {
        canEdit: false,
        canDelete: false,
        canCreate: false,
      };
    }

    const isAppAdmin = currentUser.role === Roles.ADMIN.value;
    const isAdmin =
      currentUser.organizationRole === OrganizationRoles.ADMIN.value;
    const isSupervisor =
      currentUser.organizationRole === OrganizationRoles.SUPERVISOR.value;
    const isInviteOfOrganization =
      invite && invite.organization === currentUser.organization?.id;

    const canManageInvite = Boolean(
      isInviteOfOrganization &&
        (isAdmin || isSupervisor) &&
        canManageRole(currentUser.organizationRole, invite?.role),
    );

    const canCreate = isAdmin || isSupervisor || isAppAdmin;
    const canEdit = canManageInvite || isAppAdmin;
    const canDelete = canManageInvite || isAppAdmin;

    return {
      canEdit,
      canDelete,
      canCreate,
    };
  }, [invite, currentUser]);
};
